export default {
  path: "/faq",
  name: "Frequently Asked Questions",
  htmlContent: "faq.html",
  headings: [
    { id: "printing", text: "Printing", type: "heading" },
    { id: "print-selection", text: "Print Only Selection", type: "heading" },
    {
      id: "background-graphics",
      text: "I want the Critical Data Item boxes to be red. How do I achieve this?",
      type: "heading",
    },
    {},
  ],
};
